import HousekeepingService from "../services/Housekeeping/HousekeepingService";
import asyncTaskWatcher from "./asyncTaskWatcher";
import log from "./logging";

// This is the main app hub events for any signalR events broadcasted
const registerAppEvents = ({
  updateHousekeepingReport,
}: {
  updateHousekeepingReport: (facilityId: string, reportId?: string, roomId?: string) => void;
}) => {
  const connection = asyncTaskWatcher.getConnection();
  if (!connection) {
    log.error('Cannot register events: connection is not initialized. Call startChatHubConnection first.');
    return;
  }

  connection.on("UpdateHousekeepingReport", updateHousekeepingReport);
};

const updateHousekeepingReport = (facilityId: string, reportId?: string, roomId?: string) => {
  HousekeepingService.getUpdates(facilityId, reportId, roomId)
}
const unregisterAppEvents = () => {
  const connection = asyncTaskWatcher.getConnection();
  if (!connection) return;

  connection.off("UpdateHousekeepingReport");
};

const hubAppEvents = {registerAppEvents, unregisterAppEvents, updateHousekeepingReport};

export default hubAppEvents;